import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currentClassId: null,
  classNameById: {},
  classNumById: {},
  classStatsById: {},
};

const teachingManagementSlice = createSlice({
  name: 'teachingManagement',
  initialState,
  reducers: {
    setCurrentClassId(state, action) {
      state.currentClassId = action.payload ? String(action.payload) : null;
    },
    upsertClassMeta(state, action) {
      const { classId, name, classNum } = action.payload || {};
      if (!classId) return;
      const id = String(classId);
      if (name !== undefined) {
        state.classNameById[id] = String(name);
      }
      if (classNum !== undefined && classNum !== null && classNum !== '') {
        state.classNumById[id] = String(classNum);
      }
    },
    setClassStats(state, action) {
      const { classId, studentCount, courseCount } = action.payload || {};
      if (!classId) return;
      const id = String(classId);
      state.classStatsById[id] = {
        studentCount: studentCount ?? state.classStatsById[id]?.studentCount,
        courseCount: courseCount ?? state.classStatsById[id]?.courseCount,
      };
    },
    clearTeachingManagement() {
      return initialState;
    },
  },
});

export const {
  setCurrentClassId,
  upsertClassMeta,
  setClassStats,
  clearTeachingManagement,
} = teachingManagementSlice.actions;

export default teachingManagementSlice.reducer;
